import { withProps } from 'recompose'
import Eurotrip from './Eurotrip'
import { CUSTOMER_MESSAGES } from '../../../../../constants/customerMessages'

export default {
  GemContainer: withProps({
    qaTag: 'euroTripGem',
    amount: 15000
  }),
  Detail: Eurotrip,
  question: CUSTOMER_MESSAGES.CASHOUT_OPTIONS.message,
  topic: CUSTOMER_MESSAGES.CASHOUT_OPTIONS.topic,
  topicKey: CUSTOMER_MESSAGES.CASHOUT_OPTIONS.topicKey
}
